// extracted by mini-css-extract-plugin
export default {"DeleteModalContainer":"DeleteModal_DeleteModalContainer__1gNkv","ButtonsContainer":"DeleteModal_ButtonsContainer__eN5sv"};